/*
 * @Copyright: 网易集成平台
 * @Author: xiaowenwen
 * @Date: 2021-12-20 11:47:52
 * @LastEditTime: 2021-12-20 11:49:18
 * @Description:邮箱web登陆日志
 */
import http, { formConfig } from "@/utils/http";
const url = action => `/sync/userlogin/${action[0]}`;

export default class LOG {
  static LIST(params) {
    return http.get(url`list`, { params });
  }
  static DELETE(data) {
    return http.post(url`delete`, data, formConfig);
  }
}
